import { Engine } from "../engine";
import { CustomAction, CustomParams, ExportType, ExtensionOptions } from "../../types";
import { Dependency } from "../dependencyLoader";

const DEFAULT_OPTIONS: ExtensionOptions = {
	defaultData: true,
}

export abstract class ExtensionController implements Disposable {

	constructor(readonly engine: Engine) { }

	beforeDependencies() : void|Promise<void> { }
	afterDependencies() : void|Promise<void> { }
	beforeRender() : void|Promise<void> { }
	afterRender(): void | Promise<void> { }

	/** Called when the engine's main resource content is replaced (e.g. by the editor preview). */
	onMainResourceChange(content: string) { }

	onAction(id: string, data?: any) { }

	getCustomActions(): CustomAction[] {
		return [];
	}

	getExportTypes(): ExportType[] {
		return [];
	}

	export(type: ExportType) : void|Promise<void> { }

	modifyDependencies(dependencies: Dependency[]) {
		return dependencies;
	}

	protected initOptions(options?: Partial<ExtensionOptions>) {
		return {...DEFAULT_OPTIONS, ...options};
	}

	getOptions() : Promise<ExtensionOptions>|ExtensionOptions {
		return this.initOptions();
	}

	abstract render(target: HTMLElement, template: string, data?: CustomParams): Promise<void>;

	[Symbol.dispose](): void|Promise<void> { }

}
